import { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { Plus } from "lucide-react";
import { MaskedHeading } from "../Reveal";
import { FAQ } from "../../data/content";
import { track } from "../../lib/analytics";

const Item = ({ item, index }) => {
  const [open, setOpen] = useState(false);
  const reduced = useReducedMotion();

  const toggle = () => {
    const next = !open;
    setOpen(next);
    if (next) track("faq_open", { question_index: index });
  };

  return (
    <div className="faq-item" data-testid={`faq-item-${index}`}>
      <button
        className="faq-item__trigger"
        onClick={toggle}
        aria-expanded={open}
        aria-controls={`faq-answer-${index}`}
        data-testid={`faq-trigger-${index}`}
      >
        <span>{item.q}</span>
        <Plus
          size={26}
          strokeWidth={1.4}
          className={`faq-item__icon ${open ? "faq-item__icon--open" : ""}`}
        />
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            id={`faq-answer-${index}`}
            className="faq-item__answer"
            role="region"
            initial={reduced ? { opacity: 0 } : { height: 0, opacity: 0 }}
            animate={reduced ? { opacity: 1 } : { height: "auto", opacity: 1 }}
            exit={reduced ? { opacity: 0 } : { height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          >
            <p className="faq-item__answer-inner">{item.a}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default function Faq() {
  return (
    <section className="section bg-marine py-24 md:py-40" data-testid="faq-section">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <span className="chapter-num">CHAPITRE 10 — QUESTIONS FRÉQUENTES</span>
        <MaskedHeading
          tag="h2"
          className="font-display font-medium text-[clamp(2.2rem,5vw,4rem)] leading-none tracking-tight text-pearl mt-6 mb-12"
          lines={["Ce qu'il est bon", "de savoir avant d'entrer."]}
        />
        <div>
          {FAQ.map((item, i) => (
            <Item key={i} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
